import { Action } from '@ngrx/store';
import { ResultAR } from 'src/app/models/SicarMap/resultAR.model';

export const SET_RESULTAR = '[RED_AGUA] SET';


export class SetRARAction implements Action {
  readonly type = SET_RESULTAR;
  constructor(public Result: ResultAR) {}
}

export type RsultARActions =
  | SetRARAction;